import { useEffect, useState } from "react";

export default function Preloader() {
  const [isExiting, setIsExiting] = useState(false);
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    // Keep the preloader visible initially.
    const exitTimer = window.setTimeout(() => {
      setIsExiting(true);
    }, 1200);

    // Remove it only AFTER the slide-out animation finishes.
    const removeTimer = window.setTimeout(() => {
      setIsDone(true);
    }, 1900);

    return () => {
      window.clearTimeout(exitTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  if (isDone) return null;

  return (
    <div
      className={`preloader ${isExiting ? "preloader--exit" : ""}`}
      aria-hidden="true"
    >
      <div className="preloader-brand">
        <img src="/assets/images/kizak_R_logo_v1.png" alt="" />
      </div>

      <div className="preloader-curtain" />
    </div>
  );
}